import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SiteCtx = createContext(null);
const AuthCtx = createContext(null);
const CartCtx = createContext(null);

export function Providers({ children }) {
  const [site, setSite] = useState(null);
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("kf_cart") || "[]");
    } catch (e) {
      return [];
    }
  });
  useEffect(() => {
    api.get("/public/settings").then((r) => setSite(r.data)).catch(() => setSite({}));
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  useEffect(() => {
    localStorage.setItem("kf_cart", JSON.stringify(cart));
  }, [cart]);
  const add = useCallback((item) => {
    setCart((c) => {
      const key = [item.kind, item.artwork_id, item.variant_id, item.find_id].join(":");
      const ex = c.find((x) => x.key === key);
      if (ex && item.kind !== "print") return c;
      if (ex) return c.map((x) => (x.key === key ? { ...x, qty: Math.min(20, x.qty + (item.qty || 1)) } : x));
      return [...c, { ...item, key, qty: item.qty || 1 }];
    });
  }, []);
  const setQty = (key, qty) => setCart((c) => c.map((x) => (x.key === key ? { ...x, qty: Math.max(1, Math.min(20, qty)) } : x)));
  const remove = (key) => setCart((c) => c.filter((x) => x.key !== key));
  const clear = () => setCart([]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return (
    <SiteCtx.Provider value={site}>
      <AuthCtx.Provider value={{ user, setUser, logout }}>
        <CartCtx.Provider value={{ cart, add, setQty, remove, clear }}>{children}</CartCtx.Provider>
      </AuthCtx.Provider>
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
export const useAuth = () => useContext(AuthCtx);
export const useCart = () => useContext(CartCtx);
export const hasRole = (u, ...roles) => !!u && (u.roles?.includes("owner") || roles.some((r) => u.roles?.includes(r)));
